import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type StoreService from 'scaleflow/services/store';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

type Params = {
  product_id: string;
};
class ScansScanProductRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare betaToggle: BetaToggleService;

  model({ product_id }: Params) {
    return this.store.findRecord('section', product_id, { include: 'all' });
  }

  afterModel() {
    if (this.betaToggle.hideObservations) {
      this.router.transitionTo('scans.scan.product.automated-reports');
    }
  }

  @action
  error(error: any) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('scans.scan');
      return;
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(ScansScanProductRoute);
